import Modal from "react-bootstrap/Modal";
import React, {useEffect, useState, useRef} from "react";
import Button from "react-bootstrap/Button";
import Image from "react-bootstrap/Image";
import LoaderService from "../../RetroAssets.System/LoaderService";
import {DateBox, NumberBox} from "devextreme-react";
import {alert} from "devextreme/ui/dialog";
import cl from "../../RetroAssets.System/Utilities";
import RetroFormItem from "../../RetroAssets.System/FormGroup";
import utilities from "../../RetroAssets.System/Utilities";

function AutoGenerateTransactions(props) {
    const {show, showInterestField = false} = props
    const [showModal, setShowModal] = useState(false);

    const [details, setDetails] = useState({
        StartDate: null,
        NumberOfInstallments: null,
        MonthGap: null,
        Amount: null,
        PrincipalAmount: null
    })

    const modalClose = () => {
        setDetails({})
        props.handleClose()
        setDetails({})
        setShowModal(false);
    }

    useEffect(() => {
        if (!show) return
        setDetails({
            StartDate: null,
            NumberOfInstallments: null,
            MonthGap: null,
            Amount: null,
            PrincipalAmount: null
        })
        setShowModal(true)
    }, [show])

    const valueChangeHandler = e => {
        if (!e.event) return
        let prop = e.component.option("property")
        if (e.component.NAME === "dxDateBox") {
            const text = (e.component.option('text') || '').toString()
            e.value = cl.normalizeAndValidateDate(text)
        }
        setDetails({
            ...details,
            [prop]: e.value
        })
    }

    const saveData = () => {
        if (details.StartDate === null) return alert("Please enter a Start Date.", "Warning!")
        if (details.NumberOfInstallments === null) return alert("Please enter Number Of Installments.", "Warning!")
        if (details.MonthGap === null) return alert("Please enter Gap Between Installments.", "Warning!")
        if (details.Amount === null) return alert("Please enter Amount.", "Warning!")
        if (showInterestField && details.PrincipalAmount === null) return alert("Please enter Principal amount.", "Warning!")

        props.isUpdated(details)
        modalClose()
    }

    return (<Modal show={showModal} onHide={modalClose} centered dialogClassName="modal-50w prop-img-slider"
                   backdrop="static" keyboard={false}>
        <Modal.Header closeButton className="border-0 pb-0 modal-header">
            <Modal.Title className="fs-5 fw-bold">
                <span>AUTO GENERATE TRANSACTIONS</span>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body className="pt-3">
            <div className="py-2 tabs-border" id="ManageTransaction_DetailsTab">
                <div className="row tabsContent">
                    <div className="col-sm-12">
                        <div className="row">
                            {/*StartDate*/}
                            <div className="col-sm-12 col-md-12">
                                <RetroFormItem
                                    label={"Start Date"}
                                    mandatory={false}
                                    valueField={
                                        <DateBox
                                            displayFormat={"dd/MM/yyyy"}
                                            inputAttr={{class: "form-control"}}
                                            elementAttr={{class: "input-group"}}
                                            placeholder="Start Date"
                                            property={"StartDate"}
                                            value={details["StartDate"]}
                                            onValueChanged={valueChangeHandler}
                                        />}
                                ></RetroFormItem>
                            </div>
                            {/*NumberOfInstallments*/}
                            <div className="col-sm-12 col-md-12">
                                <RetroFormItem
                                    label={"Number Of Installments"}
                                    mandatory={false}
                                    valueField={
                                        <NumberBox
                                            inputAttr={{class: "form-control"}}
                                            elementAttr={{class: "input-group"}}
                                            placeholder="Number Of Installments"
                                            property={"NumberOfInstallments"}
                                            value={details["NumberOfInstallments"]}
                                            onValueChanged={valueChangeHandler}
                                        />}
                                ></RetroFormItem>
                            </div>
                            {/*MonthGap*/}
                            <div className="col-sm-12 col-md-12">
                                <RetroFormItem
                                    label={"Gap Between Installments [in Months]"}
                                    mandatory={false}
                                    valueField={
                                        <NumberBox
                                            inputAttr={{class: "form-control"}}
                                            elementAttr={{class: "input-group"}}
                                            placeholder="Gap Between Installments [in Months]"
                                            property={"MonthGap"}
                                            value={details["MonthGap"]}
                                            onValueChanged={valueChangeHandler}
                                        />}
                                ></RetroFormItem>
                            </div>
                            {/*Amount, PrincipalAmount*/}
                            {showInterestField ?
                                <>
                                    {/*PrincipalAmount*/}
                                    <div className="col-sm-12 col-md-12">
                                        <RetroFormItem
                                            label={"Principal Amount"}
                                            mandatory={false}
                                            valueField={
                                                <NumberBox
                                                    inputAttr={{class: "form-control"}}
                                                    elementAttr={{class: "input-group"}}
                                                    placeholder="Principal Amount"
                                                    property={"PrincipalAmount"}
                                                    value={details["PrincipalAmount"]}
                                                    onValueChanged={valueChangeHandler}
                                                    format={"#,#00.00"}
                                                />}
                                        ></RetroFormItem>
                                    </div>
                                    {/*Amount*/}
                                    <div className="col-sm-12 col-md-12">
                                        <RetroFormItem
                                            label={"Interest Amount"}
                                            mandatory={false}
                                            valueField={
                                                <NumberBox
                                                    inputAttr={{class: "form-control"}}
                                                    elementAttr={{class: "input-group"}}
                                                    placeholder="Interest Amount"
                                                    property={"Amount"}
                                                    value={details["Amount"]}
                                                    onValueChanged={valueChangeHandler}
                                                    format={"#,#00.00"}
                                                />}
                                        ></RetroFormItem>
                                    </div>
                                </> :
                                <>
                                    {/*Amount*/}
                                    <div className="col-sm-12 col-md-12">
                                        <RetroFormItem
                                            label={"Amount"}
                                            mandatory={false}
                                            valueField={
                                                <NumberBox
                                                    inputAttr={{class: "form-control"}}
                                                    elementAttr={{class: "input-group"}}
                                                    placeholder="Amount"
                                                    property={"Amount"}
                                                    value={details["Amount"]}
                                                    onValueChanged={valueChangeHandler}
                                                    format={"#,#00.00"}
                                                />}
                                        ></RetroFormItem>
                                    </div>
                                </>
                            }


                        </div>
                    </div>
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer className="pt-2">
            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                    onClick={saveData}>
                Generate Transactions
            </Button>
            <Button variant="outline-primary" className="flex-shrink-0 me-3"
                    onClick={modalClose}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>)
}

export default AutoGenerateTransactions;